import {CSSProperties, useRef, useState} from 'react';
import useOnWindowScroll from '../../common/hook/useOnWindowScroll';
import {HEADER_HEIGHT} from '../../common/scss/util/variable';
import {EVENT_TOP_HEIGHT} from '../common';

export default function useGradientStyle(bgColor?: string) {
  const [gradientStyle, setGradientStyle] = useState(getGradientStyle());
  const showGradientColorRef = useRef(false);

  useOnWindowScroll({
    onScroll: scrollY => {
      const showGradientColor = scrollY >= EVENT_TOP_HEIGHT - HEADER_HEIGHT;
      // 스타일 "객체"를 변경하기 때문에 객체가 매번 변경되는 것을 막기 위해(매번 리렌더링),
      // 이전 상태를 비교해서 스타일 객체를 필요한 경우에만 새로 생성한다.
      if (showGradientColorRef.current !== showGradientColor) {
        showGradientColorRef.current = showGradientColor;
        setGradientStyle(
          getGradientStyle(showGradientColor ? bgColor : 'transparent')
        );
      }
    },
  });

  return gradientStyle;
}

const getGradientStyle = (backgroundColor = 'transparent'): CSSProperties => ({
  transition: 'background-color 0.2s',
  backgroundColor,
  height: `${HEADER_HEIGHT}px`,
  opacity: 1,
});
